$( document ).ready(function() {
	$('.service__content__right table').wrap('<div class="table-wrap"></div>');
	$('.service__content__right table').stacktable({myClass:'responsive-table'});
});